module.exports = __webpack_public_path__ + "images/icon-location.5243d306efb32e0c87a0.svg";


//////////////////
// WEBPACK FOOTER
// ./resources/images/icon-location.svg
// module id = BUC6
// module chunks = 24